import { render, staticRenderFns } from "./GastosTab.vue?vue&type=template&id=2f40543a&scoped=true"
import script from "./GastosTab.vue?vue&type=script&lang=js"
export * from "./GastosTab.vue?vue&type=script&lang=js"
import style0 from "./GastosTab.vue?vue&type=style&index=0&id=2f40543a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f40543a",
  null
  
)

export default component.exports